"use client"

import * as React from "react"

interface ResetSuccessNoticeProps { message: string }

export function ResetSuccessNotice({ message }: ResetSuccessNoticeProps) {
  React.useEffect(() => {
    window.history.replaceState({}, "", "/login")
  }, [])

  return <p role="status" className="mb-4 rounded-md bg-primary/10 px-3 py-2 text-sm text-primary">{message}</p>
}
